import React, { Fragment } from 'react'
import { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { userUpdatePasswordAction, clearErrorAction, userLoadingAction } from '../../redux/actions/userAction'
import swal from 'sweetalert';
import Loader from '../../layout/loader';
import './updatePassword.css'
import { UPDATE_USER_PASSWORD_RESET } from '../../redux/constants/userConstants'
import updatePasswordImage from '../../images/undraw_Vault_re_s4my.png'
import MetaTag from '../../layout/MetaTag'

function UpdatePassword() {
    const history = useHistory();
    const dispatch = useDispatch();

    const { error, loading } = useSelector(state => state.user)
    const { error: updateError, loading: updateLoading, isUpdated } = useSelector(state => state.profileUpdateByUser)


    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [newConfirmPassword, setNewConfirmPassword] = useState('')

    // on submit fuction 

    const submitHandler = async (e) => {
        e.preventDefault();
        if (newPassword.length < 6) {
            return swal({
                title: "Validation Error",
                text: "New password should be at least 6 characters.",
                icon: "info",
            })
        }
        if (newPassword !== newConfirmPassword) {
           return swal({
                title: "Validation Error",
                text: "both password and confirm password should be same...!",
                icon: "info",
            })
        }
        dispatch(userUpdatePasswordAction(oldPassword, newPassword, newConfirmPassword))
    }

    useEffect(() => {
        if (error) {
            swal({
                title: "Error",
                text: error,
                icon: "error",
            })
            dispatch(clearErrorAction)
        }

        if (updateError) {
            swal({
                title: "Error",
                text: updateError,
                icon: "error",
            })
            dispatch(clearErrorAction)
        }


        if (isUpdated) {
            swal({
                title: "Updated",
                text: "Your Passwords has updated Successfully !!",
                icon: "success",
            })
            dispatch(userLoadingAction())
            history.push('/userprofile')
            dispatch({ type: UPDATE_USER_PASSWORD_RESET })
        }


    }, [dispatch, error, history, isUpdated, updateError])

    return (
        <Fragment>
             <MetaTag title={'IM Online Shopping Update Password To Stay Proctected !'}   />
            {updateLoading ? <Loader /> : (<Fragment>
                {loading ? <Loader /> : <Fragment>
                    <main className='password-update-page'>
                        <section className='password-update-shell'>
                            <div className='password-update-visual'>
                                <span>Account security</span>
                                <h1>Keep your IM account protected</h1>
                                <p>Use a strong password that you do not use on any other shopping or payment account.</p>
                                <img src={updatePasswordImage} alt='Secure password update' />
                                <div className='password-update-notes'>
                                    <span>Private checkout</span>
                                    <span>Secure orders</span>
                                    <span>Account safety</span>
                                </div>
                            </div>

                            <div className='password-update-form-card'>
                                <div className='password-update-heading'>
                                    <span>Password settings</span>
                                    <h2>Update password</h2>
                                    <p>Confirm your current password, then choose a new one with at least 6 characters.</p>
                                </div>

                                <form onSubmit={submitHandler}>
                                    <div className='password-update-field'>
                                        <label htmlFor='old-password'>Current password</label>
                                        <input
                                            id='old-password'
                                            type="password"
                                            placeholder='Enter current password'
                                            className='old-password-field'
                                            required
                                            value={oldPassword}
                                            onChange={(e) => setOldPassword(e.target.value)}
                                        />
                                    </div>

                                    <div className='password-update-field'>
                                        <label htmlFor='new-password'>New password</label>
                                        <input
                                            id='new-password'
                                            type="password"
                                            placeholder='Enter new password'
                                            className='old-password-field'
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className='password-update-field'>
                                        <label htmlFor='confirm-new-password'>Confirm new password</label>
                                        <input
                                            id='confirm-new-password'
                                            type="password"
                                            placeholder='Confirm new password'
                                            className='old-password-field'
                                            value={newConfirmPassword}
                                            onChange={(e) => setNewConfirmPassword(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className='password-update-actions'>
                                        <Link to='/userprofile'>Cancel</Link>
                                        <button>Update Password</button>
                                    </div>
                                </form>
                            </div>
                        </section>
                    </main>

                </Fragment>}

            </Fragment>)}


        </Fragment >
    )
}

export default UpdatePassword
